// Single source of truth for the session token. sessionStorage wins because super-admin
// "login as" keeps its impersonated session there (tab-scoped) without touching the real one.
const TOKEN_KEY = "user_token";
const IMPERSONATION_FLAG = "loginAsInviteUserValue";

export const getToken = () =>
  sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);

export const tokenStorage = () =>
  sessionStorage.getItem(TOKEN_KEY) ? sessionStorage : localStorage;

export const setToken = (token) => tokenStorage().setItem(TOKEN_KEY, token);

export const readAuthFlag = (key) => sessionStorage.getItem(key) || localStorage.getItem(key);

export const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
  } catch (e) {
    return null;
  }
};

export function clearAuthStorage() {
  if (sessionStorage.getItem(TOKEN_KEY)) {
    // Impersonation tab: end only this tab's session, keep the admin's real one.
    sessionStorage.clear();
    return;
  }
  const dontshow = localStorage.getItem("dontshow");
  localStorage.clear();
  sessionStorage.clear();
  if (dontshow) localStorage.setItem("dontshow", "dontShow");
  localStorage.setItem("acceptedCookiePolicyPrompt", true);
}

// For screens that reset sessionStorage state but must keep an impersonated session alive.
export function clearSessionKeepingAuth() {
  const token = sessionStorage.getItem(TOKEN_KEY);
  const flag = sessionStorage.getItem(IMPERSONATION_FLAG);
  sessionStorage.clear();
  if (token) sessionStorage.setItem(TOKEN_KEY, token);
  if (flag) sessionStorage.setItem(IMPERSONATION_FLAG, flag);
}
